import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from 'primereact/panel';
import {Dropdown} from 'primereact/dropdown';
import {DataTable} from 'primereact/datatable';
import axios from '../../../axios-url';
import {Column} from 'primereact/column';
import {Calendar} from 'primereact/calendar';
import {InputSwitch} from 'primereact/inputswitch';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';    
import moment from 'moment';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import {InputMask} from 'primereact/inputmask';
import {  DROPDOWN_CONFIG, VENDOR_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS, TIME_DURATION, REDIRECT_TO_URL } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import { filter } from 'lodash';

class NumberingScheme extends Component {
    state = {
        docType : null,
        docDocumentNo : null,
        display : true,
        rows: [],
        type : 'add',
        City : null,
        Country : null,
        vendorId : '',
        vendorNo : '',
        businessType : '',
        vendordocs :[],
        VendorType : null,
        DocExpiryDate : '',
        DocIssuDate : '',
        vendorName : '',
        Address : '',
        billingName : '',
        billingPosition : '',
        billingEmail : '',
        timesheetName : '',
        timesheetPosition : '',
        timesheetEmail : '',
        procurementName : '',
        procurementPosition : '',
        procurementEmail : '',
        actionType : '',
        taxtIn : '',
        CrNo : '',
        bank : '',
        bankBranch : '',
        bankAddress : '',
        bankIban : '',
        isActive : false,
        Blocked : false,
        billingMobile: '',
        timesheetMobile : '',
        procurementMobile : '',
        rowData : null,

        //state for numbering scheme 
    NumberRange_ID: '',
    MODULE_TYPE: '',
    Tx_Type: '',
    Show_TxPrefix: false,
    Tx_Prefix_Text: '',
    Show_Year: false,
    Show_Month: false,
    No_Width: 0,
    Width_Flag: 0,
    Start_No: '',
    Start_Flag: 0,
    Curnt_No: '',
    T_Reset: 0,
    Start_D_No: '',
    Strt_DNo_Flag: 0,
    Curnt_D_No: '',
    CREATEDBY: '',
    CREATEDDATE: '',
    C_YEAR: '',
    Company_ID: '',
    PROCESSNUM: '',
    ModuleNum: null,
 


    }

    

    componentDidMount(){    
        const { fetchSubordinatesLists,getModuleLists,getMasterTableList } = this.props;
        console.log(this.props.loggedUserDetail);
   
    getModuleLists();
    fetchSubordinatesLists(this.props.loggedUserDetail.empID, this.props.loggedUserDetail.CompanyId);



    
  
       
        let type = this.props.match.params.type;
        
        if (type !=='add'){
            let vendorId = this.props.match.params.id;
            getMasterTableList(`Employee/GetVendor?VendorId=${vendorId}`);
        }   
        
        
        
        // this.getAccess = HASACCESS(VENDOR_SUBMENU_ID);
        // this.props.getMasterKeywordList('City'); 
        // this.props.getMasterKeywordList('VendorType');
        // this.props.getMasterKeywordList('Country');
        
        if(type !== 'add'&& this.props.tableLists.length>0){
            setTimeout(() => {
                
                this.fetchSingleProcess();
            },1000)
        }
    }

    
    fetchSingleProcess = () =>{
        
        
        let type = this.props.match.params.type;
        let VendorMaster = this.props.tableLists;
        let vendors = VendorMaster.vendor;
        let vendordocuments = [];
        vendordocuments = VendorMaster.vendorDocuments;
        

        
        
        var data = {
                    type:type,
                    
                    vendorId : vendors.vendorId,
                    vendorNo : vendors.vendorNo,
                    VendorType : vendors.businesstype,
                    vendorName : vendors.vendorName,
                    Address : vendors.address,
                    billingName : vendors.contactPersonBilling,
                    billingPosition : vendors.contactPositionBilling,
                    billingEmail : vendors.emailBilling,
                    timesheetName : vendors.contactPersonTimesheet,
                    timesheetPosition : vendors.contactPositionTimesheet,
                    timesheetEmail : vendors.emailTimesheet,
                    procurementName : vendors.contactPersonProcurement,
                    procurementPosition : vendors.contactPositionProcurement,
                    procurementEmail : vendors.emailProcurement,
                    actionType : vendors.actionType,
                    taxtIn : vendors.taxtin,
                    CrNo : vendors.crno,
                    bank : vendors.bank,
                    bankBranch : vendors.bankbranch,
                    bankAddress : vendors.bankaddress,
                    bankIban : vendors.bankiban,
                    isActive : vendors.isactive,
                    Blocked : vendors.blocked,
                    billingMobile: vendors.contactnumberbilling,
                    timesheetMobile : vendors.contactnumbertimesheet,
                    procurementMobile : vendors.contactnumberprocurement,
                    City : vendors.city,
                    Country : vendors.country,
                    vendordocs :  vendordocuments,
                    
                    vid : vendors.id
                    

                    
                    

                }
                this.setState(data);
                
                
            }
        




    actionTemplate = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.removeField(rowIndex)} ></Button>
        </div>;
    }
    // DocIssuDate: (this.state.DocIssuDate!==null) ? new Date(this.state.DocIssuDate) : '', DocExpiryDate: (this.state.DocExpiryDate!==null) ? new Date(this.state.DocExpiryDate) : ''

    documentAdd = () => {

        let newDoc = { docType: this.state.docType, docDocumentNo: this.state.docDocumentNo };
  
        let docValue = [...this.state.vendordocs, newDoc];
      
        this.setState({vendordocs:docValue})
    }

    addVisaQuota = () => {

        let newDoc = {visaType : this.state.visaType, usedQ:this.state.usedQ,balanceQ:this.state.balanceQ,allocated:0};
        let docValue = [...this.state.VisaQuota, newDoc];
        this.setState({VisaQuota:docValue,usedQ:'',balanceQ:'',allocated:''})
    }

    docActionTemplate = (rowData, column) => {
        
        let rowIndex = column.rowIndex;
        
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.deleteDocType(rowIndex)}></Button>
        </div>;
    }

    
    typeEditor = (props) => {
        let types = [
            {label:'Own',value:'Own'},
            {label:'Dependent',value:'Dependent'}
        ];

        return (
            <Dropdown value={props.value[props.rowIndex].depType} options={types}
                    onChange={(e) => this.onEditorValueChange(props, e.value)} style={{width:'100%'}} placeholder="---Select---"/>
        );
    }

    docTypeEditor = (props) => {
        let types = [
            {label:'Passport',value:'Passport'},
            {label:'Driving License',value:'Driving License'},
            {label:'Iqama',value:'Iqama'}
        ];

        return (
            <Dropdown value={props.value[props.rowIndex].documentType} options={types}
                    onChange={(e) => this.onEditorValueChange(props, e.value)} style={{width:'100%'}} placeholder="---Select---"/>
        );
    }

    deleteDocType = (removeIndex) => {

        const updatedVendorValue = this.state.vendordocs.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({vendordocs:updatedVendorValue})

    }

    add = () => {
        

        let VendorDocuments = []
        let Vendor = {
            
            VendorNo : this.state.vendorNo,
            Businesstype : this.state.VendorType,
            VendorName : this.state.vendorName,
            Address : this.state.Address,
            City : this.state.City,
            Country : this.state.Country,
            ContactPersonBilling : this.state.billingName,
            ContactPositionBilling : this.state.billingPosition,
            EmailBilling : this.state.billingEmail,
            ContactPersonTimesheet : this.state.timesheetName,
            ContactPositionTimesheet : this.state.timesheetPosition,
            EmailTimesheet : this.state.timesheetEmail,
            ContactPersonProcurement : this.state.procurementName,
            ContactPositionProcurement  : this.state.procurementPosition,
            EmailProcurement : this.state.procurementEmail,
            ActionType : this.state.actionType,
            Taxtin : this.state.taxtIn,
            Crno : this.state.CrNo,
            Bank : this.state.bank,
            Bankbranch : this.state.bankBranch,
            Bankaddress : this.state.bankAddress,
            Bankiban : this.state.bankIban,
            Isactive : this.state.isActive,
            Blocked : this.state.Blocked,
            Contactnumberbilling: this.state.billingMobile,
            Contactnumbertimesheet : this.state.timesheetMobile,
            Contactnumberprocurement : this.state.procurementMobile
        }

        //number scheme payload
        const numberingSchemePayload = {
    NumberRange_ID: this.state.NumberRange_ID,
    MODULE_TYPE: this.state.ModuleNum,
    Tx_Type: this.state.Tx_Type,
    Show_TxPrefix: this.state.Show_TxPrefix ? 1 : 0,
    Tx_Prefix_Text: this.state.Tx_Prefix_Text,
    Show_Year: this.state.Show_Year ? 1 : 0,
    Show_Month: this.state.Show_Month ? 1 : 0,
    No_Width: this.state.No_Width,
    Width_Flag: this.state.Width_Flag,
    Start_No: this.state.Start_No,
    Start_Flag: this.state.Start_Flag,
    Curnt_No: this.state.Curnt_No,
    T_Reset: this.state.T_Reset,
    Start_D_No: this.state.Start_D_No,
    Strt_DNo_Flag: this.state.Strt_DNo_Flag,
    Curnt_D_No: this.state.Curnt_D_No,
    CREATEDBY: this.props.loggedUserDetail.empID,
    CREATEDDATE: moment().toISOString(),
    C_YEAR: this.state.C_YEAR,
    Company_ID: this.props.loggedUserDetail.CompanyId,
    PROCESSNUM: this.state.PROCESSNUM
    // ...other fields as needed
};

        
        VendorDocuments = this.state.vendordocs.map(list => {
            return {
                
                
                DocType :list.docType,
                DocDocumentNo :list.docDocumentNo,
                DocIssuPlace :null,
                Createdby :null,
                Createddate :null,
                Updatedby :null,
                Updateddate :null,
                CompanyId :null,
                IsActive :null,
                UploadPath : null,
                FileName : null,
                Extension : null,
                Status : null
            }
        } ) 

        let VendorMaster = []
        if(this.state.type === 'edit'){
           
            Vendor.VendorId = this.props.match.params.id;  
            Vendor.Id = this.state.vid 
            
            
            var updatedVendorDocuments = VendorDocuments.map((doc) => {
                doc.Vendordocumentid = this.state.vendordocs[0].vendordocumentid;
                doc.Id = this.state.vendordocs[0].id;
                  return doc } )
                
                

            VendorMaster  = {
                    Vendor : Vendor,
                    VendorDocuments : updatedVendorDocuments
                } 
             } 
            
            
        

        if(this.state.type === 'add'){
            VendorMaster  = {
            Vendor : Vendor,
            VendorDocuments : VendorDocuments
        }}

        
        
        
        // this.props.processDynamicData('Vendor',this.state.type,VendorMaster,'Employee/GetVendor?VendorId=${this.props.match.params.id}');
        
        this.props.processDynamicData('Vendor',this.state.type,VendorMaster,'Employee/GetVendorList');  
    }

    resetData = () => {
        this.setState ({    
        docType : null,
        docDocumentNo : null,
        display : true,
        rows: [],
        type : 'add',
        City : null,
        Country : null,
        vendorId : '',
        vendorNo : '',
        businessType : '',
        vendordocs :[],
        VendorType : null,
        DocExpiryDate : '',
        DocIssuDate : '',
        vendorName : '',
        Address : '',
        billingName : '',
        billingPosition : '',
        billingEmail : '',
        timesheetName : '',
        timesheetPosition : '',
        timesheetEmail : '',
        procurementName : '',
        procurementPosition : '',
        procurementEmail : '',
        actionType : '',
        taxtIn : '',
        CrNo : '',
        bank : '',
        bankBranch : '',
        bankAddress : '',
        bankIban : '',
        isActive : false,
        Blocked : false,
        billingMobile: '',
        timesheetMobile : '',
        procurementMobile : '',
        rowData : null
        });        
    }

    noEditor =  (props) => {
        return this.inputTextEditor(props, 'percentage');
    }
    
    issuedEditor =  (props) => {
        return this.inputCalendarEditor(props, 'issuedDate');
    }

    expiryEditor =  (props) => {
        return this.inputCalendarEditor(props, 'expiryDate');
    }

    placeEditor =  (props) => {
        return this.inputTextEditor(props, 'issuedPlace');
    }

    onEditorValueChange = (props, value) => {
        let updatedValue = [...props.value];
        updatedValue[props.rowIndex][props.field] = value;
        this.setState({documentDetails: updatedValue});
    }

    inputTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />;
    }
    
    inputCalendarEditor = (props, field) => {
        return <InputMask mask="99/99/9999" slotChar="dd/mm/yyyy" placeholder="Date" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />
        
    }

    removeField  = (removeIndex) => {

        const updatedDeptValue = this.state.rows.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({rows:updatedDeptValue})

    }

    change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})

        // setTimeout(() => {
        //     this.checkDuration();
        // },2000)
        
        
    }

    // checkDuration = () => {
    //     if(this.state.LunchStart !=='' && this.state.LunchEnd !==''){
    //         let LunchStart = new moment(this.state.LunchStart);
    //         LunchStart = LunchStart.format("HH:mm");
    //         let LunchEnd = new moment(this.state.LunchEnd);
    //         LunchEnd = LunchEnd.format("HH:mm");
    //         let LunchDuration = TIME_DURATION(LunchStart,LunchEnd);
    //         let checkTst = LunchDuration.split(':');
    //         if(checkTst[0] < 0  && checkTst[1] < 0){
    //             this.growl.show({severity: 'error', summary: null, detail: 'Lunch duration should be positive digits'});  
    //         }else{
    //             this.setState({LunchDuration:LunchDuration})
    //         }
    //     }
    // }
    // VendorRender = (rowData) => {
        
    //     let vendorType = rowData.vendorType;
    //     let VendorType = '';

    //     if(this.props.VendorType && this.props.VendorType.length > 0){
    //         VendorName = this.props.VendorType.filter((type)=>{
    //             return type.value === vendorType
    //         }).reduce((result, el) => {
    //             return el.label;
    //         },'');
    //     }
    //     return VendorType;
    // }

    render() {   

        //module list for dropdown
        let moduleLists = [];

      if(this.props.moduleLists){
            moduleLists = this.props.moduleLists;
        }

        if(this.props.success){
            REDIRECT_TO_URL('/Vendor/',this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}
        let isEnabled = (this.state.touch === true);
        // let isEnabled = (this.state.shiftName!=='' && this.state.ShiftId!=='' && this.state.Description!=='');
        return (
            <div className="p-grid ">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Numbering Scheme</h1>
           
                        <div className="p-grid mt2">
                             <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Process Num</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="PROCESSNUM" value={this.state.PROCESSNUM} placeholder="Process Num" onChange={this.change} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Number Range ID</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="NumberRange_ID" value={this.state.NumberRange_ID} placeholder="Number Range ID" onChange={this.change} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                              <label htmlFor="moduleNum">Select Module <span className="requiredColor">*</span></label>
                                 <div className="mt1">
                                <Dropdown className="p-col-12" name="ModuleNum" options={moduleLists} value={this.state.ModuleNum} onChange={e => this.setState({ ModuleNum: e.value })} autoWidth={false} placeholder="Select Module" />
                                 </div>
                                </div>
                                <div className="p-col-6 ">
  
                            </div>
                            <div className="p-col-12 p-grid">
                                <div className="p-col-6">
                                    <label className="label">Tx Type</label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="Tx_Type" value={this.state.Tx_Type} placeholder="Tx Type" onChange={this.change} />
                                    </div>
                                </div>
                                <div className="p-col-6">
                                    <label className="label">Tx Prefix Text</label>
                                    <div className="mt1">
                                        <InputText className="p-col-12" name="Tx_Prefix_Text" value={this.state.Tx_Prefix_Text} placeholder="Tx Prefix Text" onChange={this.change} />
                                    </div>
                                </div>
                                <div className="p-col-12 mt2">
                                    <label className="label">Show TxPrefix</label>
                                    <InputSwitch checked={this.state.Show_TxPrefix} name="Show_TxPrefix" onChange={e => this.setState({Show_TxPrefix: e.value})} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Show Year</label>
                                <InputSwitch checked={this.state.Show_Year} name="Show_Year" onChange={e => this.setState({Show_Year: e.value})} />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Show Month</label>
                                <InputSwitch checked={this.state.Show_Month} name="Show_Month" onChange={e => this.setState({Show_Month: e.value})} />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">No Width</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="No_Width" value={this.state.No_Width} placeholder="No Width" onChange={this.change} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Width Flag</label>
                                <div className="mt1">
                                    <InputSwitch checked={!!this.state.Width_Flag} name="Width_Flag" onChange={e => this.setState({Width_Flag: e.value ? 1 : 0})} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Start No</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="Start_No" value={this.state.Start_No} placeholder="Start No" onChange={this.change} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Start Flag</label>
                                <div className="mt1">
                                    <InputSwitch checked={!!this.state.Start_Flag} name="Start_Flag" onChange={e => this.setState({Start_Flag: e.value ? 1 : 0})} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Current No</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="Curnt_No" value={this.state.Curnt_No} placeholder="Current No" onChange={this.change} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">T Reset</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="T_Reset" value={this.state.T_Reset} placeholder="T Reset" onChange={this.change} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Start D No</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="Start_D_No" value={this.state.Start_D_No} placeholder="Start D No" onChange={this.change} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Strt DNo Flag</label>
                                <div className="mt1">
                                    <InputSwitch checked={!!this.state.Strt_DNo_Flag} name="Strt_DNo_Flag" onChange={e => this.setState({Strt_DNo_Flag: e.value ? 1 : 0})} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Current D No</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="Curnt_D_No" value={this.state.Curnt_D_No} placeholder="Current D No" onChange={this.change} />
                                </div>
                            </div>
                            {/* <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Created By</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="CREATEDBY" value={this.state.CREATEDBY} placeholder="Created By" onChange={this.change} />
                                </div>
                            </div> */}
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Created Date</label>
                                <div className="mt1">
                                  <Calendar className="width100" placeholder="created Date" name="CREATEDDATE" value={this.state.CREATEDDATE} onChange={e => this.setState({CREATEDDATE: e.value, touch: true})} dateFormat="yy-mm-dd"  showIcon/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Year</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="C_YEAR" value={this.state.C_YEAR} placeholder="Year" onChange={this.change} />
                                </div>
                            </div>
                            {/* <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Company ID</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="Company_ID" value={this.state.Company_ID} placeholder="Company ID" onChange={this.change} />
                                </div>
                            </div> */}
                           
                        </div>
                            {/* <div className="mt3">
                                <div className="p-col-12 p-md-12" style={{textAlign:'right',paddingRight:'0px'}}>
                                    <Button label="Add" style={{marginBottom:'10px'}} className="p-button-primary" onClick={this.documentAdd}/>
                                </div>
                        
                                <DataTable className="animated fadeIn" rowHover  responsive value={this.state.vendorTypes} editable={true}>
                                    <Column field="vendorType" header="Type" editor={this.typeEditor} style={{height: '3.5em'}}/>
                                    <Column field="documentType" header="Document Type" editor={this.docTypeEditor} style={{height: '3.5em'}}/>
                                    <Column field="doucmentNo" header="Document No" editor={this.noEditor} style={{height: '3.5em'}}/>
                                    <Column field="expiryDate" header="Expiry Date" editor={this.expiryEditor} style={{height: '3.5em'}}/>
                                    <Column field="issuedDate" header="Issued Date" editor={this.issuedEditor} style={{height: '3.5em'}}/>
                                    <Column field="issuedPlace" header="Issued Place" editor={this.placeEditor} style={{height: '3.5em'}}/>
                                    <Column body={this.docActionTemplate} style={{textAlign:'center', width: '8em'}}/>
                                </DataTable> 
                            </div> */}
                            
                            <div className="mt3">
                            <div className="p-grid">

                    {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Vendor Type</label>
                        <div className="mt1"><Dropdown className="p-col-12" options={this.props.VendorType} name="vendorType" value={this.state.vendorType} onChange={event => this.setState({vendorType: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Vendor Type" style={{marginTop: '0.5em'}}/></div>   
                    </div>
                     */}
                    {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Expiry Date</label>
                        <div className="mt1">
                        <Calendar className="p-col-12" name="DocExpiryDate" onChange={event => this.setState({DocExpiryDate: event.target.value})}  value={this.state.DocExpiryDate} dateFormat="yy-mm-dd" placeholder="Choose Expiry Date"/>
                        </div>                             
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Issue Date</label>
                        <div className="mt1">
                        <Calendar className="p-col-12" name="DocIssuDate" onChange={event => this.setState({DocIssuDate: event.target.value})}  value={this.state.DocIssuDate} dateFormat="yy-mm-dd" placeholder="Choose Issue Date"/>
                        </div>                             
                    </div> */}
                   

                </div>
            </div>  
                       
                            <div className="p-col-12 p-lg-12">
                                <FooterButton access={accessButton}  type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/Vendor"} />
                            </div>
                                 
           
                       
                    </div>
                         
                </div>
                
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        tableLists : state.master.tableLists,
        City: (state.keyword.City!==undefined) ? state.keyword.City : [],
        Country: (state.keyword.Country!==undefined) ? state.keyword.Country : [],
        VendorType : (state.keyword.VendorType!==undefined) ? state.keyword.VendorType : [], 
        moduleLists : state.master.keywordValuesList,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getModuleLists : () => dispatch(actions.getKeywordValues('Module')),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(NumberingScheme);